import { ContractsAnnualWorkingTimeDistributionEnum } from 'generated/resources/graphql'

import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  annualWorkingTimeDistribution?: ContractsAnnualWorkingTimeDistributionEnum
  workdaysCount?: number
  adjustedDailyMinutes?: number
}

const AnnualWorkingTimeCalculation = ({
  annualWorkingTimeDistribution,
  workdaysCount,
  adjustedDailyMinutes,
}: Props) => {
  if (!annualWorkingTimeDistribution) return null

  const getContent = () => {
    switch (annualWorkingTimeDistribution) {
      case 'limit_workdays':
        return workdaysCount
          ? i18n.t('contract_versions.time.annual_working_time.workdays', {
              workdays: workdaysCount,
            })
          : null
      case 'limit_daily_hours':
        return adjustedDailyMinutes
          ? i18n.t('contract_versions.time.annual_working_time.hours_per_day', {
              hours: minutesToText(adjustedDailyMinutes),
            })
          : null
      default:
        return null
    }
  }

  const content = getContent()
  if (!content) return null

  return (
    <Item
      id="annual_working_time_calculation"
      title={i18n.t('contract_versions.time.annual_working_time.title')}
      description={content}
    />
  )
}

export default AnnualWorkingTimeCalculation
